module.exports = __webpack_public_path__ + "static/media/about-us-1-lg.33627b0f.jpg";